var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',{staticClass:"search"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Search")])],1),_c('li',{staticClass:"account"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Account")])],1),_c('li',{staticClass:"cart"},[_c('router-link',{attrs:{"to":"/cart"}},[_vm._v("Cart")]),_c('span',{staticClass:"cart-counter"},[_vm._v("2")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }